import React from 'react';
import "./Ourjunery.css";
import journeyImage from "../img/aaaservices/robo (2).jpg"; // ek hi image, poore time fixed rahegi

const OurJourney = () => {
  const milestones = [
    { year: "2012", title: "Started Training Center at Hyderabad", text: "Expanded to new cities and built our first industrial project." },
    { year: "2014", title: "Consulting Services Launched", text: "First international client onboarded, completed large scale project." },
    { year: "2016", title: "Entered Mechanical Engineering", text: "Built flagship manufacturing unit, R&D lab set up." },
    { year: "2018", title: "Industrial Automation Provider", text: "Automated first plant, implemented AI solutions." },
    { year: "2020", title: "Digitalized 20M Sq. M Facilities", text: "Built automated warehouses, launched online platforms." },
    { year: "2022", title: "Started Building Information Modeling", text: "Collaborated with top architects, first 3D model of a complex project." },
    { year: "2024", title: "Launched Digital Graphic Media", text: "Expanded team to 200+, first international marketing campaign." },
    { year: "2025", title: "Joint Venture into IT with ETR", text: "Developed proprietary tech platform, received industry recognition awards." },
    { year: "2026", title: "Global Expansion Strategy", text: "AI-powered solutions launch, 10,000+ clients worldwide." },
  ];

  return (
    <section className="journey-section">
      <div className="journey-container">
        <div className="journey-header">
          <p className="journey-eyebrow">Our Journey</p>
          <h2 className="journey-title">15 years, one mission</h2>
        </div>

        <div className="journey-layout">
          {/* Left: fixed single image */}
          <div className="journey-image-col">
            <div className="journey-photo-frame">
              <img src={journeyImage} alt="Our Journey" loading="lazy" />
            </div>
          </div>

          {/* Right: timeline */}
          <div className="journey-timeline-wrapper">
            <div className="journey-timeline">
              <div className="journey-line" />
              {milestones.map((item, index) => {
                const colorClass = index % 2 === 0 ? "blue" : "red";
                return (
                  <div key={item.year} className={`journey-item ${colorClass}`}>
                    <div className="journey-dot">
                      <span>{index + 1}</span>
                    </div>
                    <div className="journey-content">
                      <span className="journey-year">{item.year}</span>
                      <h4 className="journey-item-title">{item.title}</h4>
                      <p className="journey-item-text">{item.text}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurJourney;